import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_HOST;




export const getBlogs = async ({ page = 1, limit = 10 }) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.get(`${API_BASE_URL}/blogs`, {
    params: { page, limit },
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });


  const resData = response.data.data;

  return {
    blogs: resData.data,
    currentPage: resData.current_page,
    lastPage: resData.last_page,
    perPage: resData.per_page,
    total: resData.total,
    nextPageUrl: resData.next_page_url,
    prevPageUrl: resData.prev_page_url,
  };
};


export const addBlog = async (formData) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.post(`${API_BASE_URL}/blogs/add`, formData, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return response.data;
};

export const updateBlog = async (formData) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.post(`${API_BASE_URL}/blogs/update`, formData, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return response.data;
};

export const getBlogById = async (id) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.get(`${API_BASE_URL}/blogs/show/${id}`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return response.data;
};

export const deleteBlogById = async (id) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.get(`${API_BASE_URL}/blogs/delete/${id}`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return response.data;
};



export const uploadEditorImage = async (file) => {
  const token = localStorage.getItem("access_token");

  const formData = new FormData();
  formData.append("image", file);

  const response = await axios.post(
    `${API_BASE_URL}/upload-image`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
};
